import roles from "constants/roles.constant";
import * as Actions from "../actions";

const initialState = {
  isAuthenticated: false,
  user: { loading: false, error: null },
  operator: null,
  role: null,
  avatar: null,
  publicIp: null,
};
const auth = (state = initialState, action) => {
  switch (action.type) {
    case Actions.AUTH_ADD_PUBLIC_IP: {
      const { publicIp } = action.payload;
      return {
        ...state,
        publicIp,
      };
    }
    case Actions.AUTH_ADD_SESSION_DATA: {
      const { operator } = action.payload;
      return {
        ...state,
        isAuthenticated: true,
        operator,
        role: operator ? roles.OPERATOR : roles.OWNER,
      };
    }
    case Actions.AUTH_REMOVE_SESSION_DATA: {
      return initialState;
    }
    case Actions.AUTH_FETCH_USER_STARTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case Actions.AUTH_FETCH_USER_SUCCESS: {
      const { ecommTransferBtwUsrs, permissions } = action.payload;

      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
          permissions: { ...permissions, ecommTransferBtwUsrs },
          loading: false,
          error: null,
        },
      };
    }
    case Actions.AUTH_FETCH_USER_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }
    case Actions.AUTH_ADD_AVATAR: {
      return {
        ...state,
        avatar: action.payload.avatar,
      };
    }
    case Actions.AUTH_PHONE_VALIDATED_SUCCESS: {
      return {
        ...state,
        user: {
          ...state.user,
          verifiedPhone: true,
        },
      };
    }
    default: {
      return state;
    }
  }
};

export default auth;
